module.exports = __webpack_public_path__ + "static/img/20.980674e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/20.png
// module id = EzQt
// module chunks = 0